// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wrapper styling */
.form-wrapper {
  max-width: 600px;
  margin: 2rem auto;
  padding: 1rem;
  background-color: #f9f9f9;
  border-radius: 8px;
  direction: rtl;
}

/* Title styling */
.form-title {
  margin-bottom: 1.5rem;
  text-align: center;
  font-size: 1.5rem;
  color: var(--primary-color);
}

/* Styling for intro text */
.intro-text {
  font-size: 16px;
  color: #333;
  margin-bottom: 20px;
  text-align: right;  /* Right-align text for RTL */
}

.intro-text ul {
  list-style-type: disc;  /* Bullet points */
  padding-left: 1rem;  /* Add space to the left of the bullets */
}

.intro-text li {
  margin-bottom: 0.5rem;  /* Space between list items */
}
.intro-text p{
  margin: 0;
}

/* Main container styling */
.form-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  max-width: 600px;
  margin: 0 auto;
  padding: 1rem;
  box-sizing: border-box; /* Add this line */
  border: 1px solid #dcdcdc; /* Light gray border */

}

/* Styling for select dropdown */
.form-container select {
  background-size: 12px;
  padding: 2rem;
}
.form-container .react-tel-input {
  display: inline-flex;        /* Ensure it behaves like a flex item */
  direction: ltr !important;
  text-align: left;
  flex: 1 1 100%;              /* Make the phone input take full width */
  min-width: 200px;
  width: 100%;
  height: 45.7px;
  border: 1px solid var(--primary-color) !important;
  border-radius: 4px;
}

.form-container .react-tel-input .form-control{
  height: 100%;
  border-radius: 4px;
  border: unset;
}
/* Form Group Styling */
.form-group {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(50% - 1rem);  /* Two items per row */
  min-width: 200px;
  box-sizing: border-box;  /* Ensure box sizing includes padding and border */

}




.form-group label {
  margin-bottom: 0.5rem;
  font-weight: bold;
  font-size: 1rem;
  text-align: right; /* Right-align labels */

}

.form-group input,
.form-group select {
  padding: 0.75rem;
  font-size: 1rem;
  border: 1px solid var(--primary-color);
  border-radius: 4px;
  box-sizing: border-box;  /* Ensure padding and borders are included in width */

}



button {
  flex: 1 1 100%;
  background-color: var(--primary-color);
  color: var(--secondary-color);
  border: none;
  cursor: pointer;
  font-weight: bold;
  padding: 0.75rem;
  margin-top: 1rem;
}

button:hover {
  background-color: var(--secondary-color);
  color: var(--primary-color);
  border: 2px var(--primary-color) solid;
}

.required-asterisk {
  color: red;
}
.input-error {
  border: 2px solid red;
}

.error-message {
  color: red;
  font-size: 12px;
}

.required-asterisk {
  color: red;
}
/* Styling for textarea */
.form-container textarea {
  width: 100%; /* Make the textarea take full width */
  padding: 0.75rem; /* Adjust padding for better spacing */
  font-size: 1rem; /* Set font size */
  border: 1px solid var(--primary-color); /* Border styling */
  border-radius: 4px; /* Rounded corners */
  box-sizing: border-box; /* Ensure padding and borders are included in width */
  resize: vertical; /* Allow vertical resizing, but restrict horizontal resizing */
}

/* Ensure the textarea takes full width and behaves like a standalone field */
.form-group.textarea-group {
  flex: 1 1 100%; /* Take the full row */
  width: 100%; /* Ensure 100% width */
  margin-bottom: 1rem; /* Add some space below the textarea */
}

/* Adjust label positioning for textarea */
.form-group.textarea-group label {
  margin-bottom: 0.5rem;
  font-weight: bold;
  font-size: 1rem;
  text-align: right; /* Right-align labels */
}
.social-media-icon {
  color: #555; /* Icon color */
  font-size: 0.75rem; /* Adjust icon size */
  margin-left: 8px; /* Space between the label and icon */
  vertical-align: middle; /* Ensure the icon is aligned vertically with the input text */
}
.enhanced-title-border {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1rem 0;
}

.enhanced-title-border::before,
.enhanced-title-border::after {
  content: '';
  height: 2px;
  width: 110px;
  margin: 0 1rem;
  background-color:var(--primary-color)
}

.enhanced-title-border .circle {
  width: 10px;
  height: 10px;
  border: 2px solid var(--primary-color);
  border-radius: 50%;
  background: transparent;
}

h1 {
  font-weight: bold;
}
.center-text{
  text-align: center;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .form-container {
    flex-direction: column;
  }

  .form-group {
    flex: 1 1 100%;  /* Single column layout on smaller screens */
    width: 100%;      /* Ensure 100% width */

    
  }

   /* Ensuring inputs take full width */
   .form-group input,
   .form-group select {
     width: 100%;      /* Make input fields take full width */
     padding: 0.75rem;
     font-size: 1rem;
     border: 1px solid var(--primary-color);
     border-radius: 4px;
   }
}

`, "",{"version":3,"sources":["webpack://./src/styles/form.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,iBAAiB,GAAG,6BAA6B;AACnD;;AAEA;EACE,qBAAqB,GAAG,kBAAkB;EAC1C,kBAAkB,GAAG,yCAAyC;AAChE;;AAEA;EACE,qBAAqB,GAAG,6BAA6B;AACvD;AACA;EACE,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB,EAAE,kBAAkB;EAC1C,yBAAyB,EAAE,sBAAsB;;AAEnD;;AAEA,gCAAgC;AAChC;EACE,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,oBAAoB,SAAS,uCAAuC;EACpE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc,eAAe,yCAAyC;EACtE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;AACA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B,GAAG,sBAAsB;EACnD,gBAAgB;EAChB,sBAAsB,GAAG,kDAAkD;;AAE7E;;;;;AAKA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,iBAAiB,EAAE,uBAAuB;;AAE5C;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB,GAAG,qDAAqD;;AAEhF;;;;AAIA;EACE,cAAc;EACd,sCAAsC;EACtC,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;AACA,yBAAyB;AACzB;EACE,WAAW,EAAE,sCAAsC;EACnD,gBAAgB,EAAE,sCAAsC;EACxD,eAAe,EAAE,kBAAkB;EACnC,sCAAsC,EAAE,mBAAmB;EAC3D,kBAAkB,EAAE,oBAAoB;EACxC,sBAAsB,EAAE,qDAAqD;EAC7E,gBAAgB,EAAE,8DAA8D;AAClF;;AAEA,6EAA6E;AAC7E;EACE,cAAc,EAAE,sBAAsB;EACtC,WAAW,EAAE,sBAAsB;EACnC,mBAAmB,EAAE,sCAAsC;AAC7D;;AAEA,0CAA0C;AAC1C;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,iBAAiB,EAAE,uBAAuB;AAC5C;AACA;EACE,WAAW,EAAE,eAAe;EAC5B,kBAAkB,EAAE,qBAAqB;EACzC,gBAAgB,EAAE,qCAAqC;EACvD,sBAAsB,EAAE,8DAA8D;AACxF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,cAAc;EACd;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc,GAAG,4CAA4C;IAC7D,WAAW,OAAO,sBAAsB;;;EAG1C;;GAEC,oCAAoC;GACpC;;KAEE,WAAW,OAAO,sCAAsC;KACxD,gBAAgB;KAChB,eAAe;KACf,sCAAsC;KACtC,kBAAkB;GACpB;AACH","sourcesContent":["/* Wrapper styling */\n.form-wrapper {\n  max-width: 600px;\n  margin: 2rem auto;\n  padding: 1rem;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  direction: rtl;\n}\n\n/* Title styling */\n.form-title {\n  margin-bottom: 1.5rem;\n  text-align: center;\n  font-size: 1.5rem;\n  color: var(--primary-color);\n}\n\n/* Styling for intro text */\n.intro-text {\n  font-size: 16px;\n  color: #333;\n  margin-bottom: 20px;\n  text-align: right;  /* Right-align text for RTL */\n}\n\n.intro-text ul {\n  list-style-type: disc;  /* Bullet points */\n  padding-left: 1rem;  /* Add space to the left of the bullets */\n}\n\n.intro-text li {\n  margin-bottom: 0.5rem;  /* Space between list items */\n}\n.intro-text p{\n  margin: 0;\n}\n\n/* Main container styling */\n.form-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  max-width: 600px;\n  margin: 0 auto;\n  padding: 1rem;\n  box-sizing: border-box; /* Add this line */\n  border: 1px solid #dcdcdc; /* Light gray border */\n\n}\n\n/* Styling for select dropdown */\n.form-container select {\n  background-size: 12px;\n  padding: 2rem;\n}\n.form-container .react-tel-input {\n  display: inline-flex;        /* Ensure it behaves like a flex item */\n  direction: ltr !important;\n  text-align: left;\n  flex: 1 1 100%;              /* Make the phone input take full width */\n  min-width: 200px;\n  width: 100%;\n  height: 45.7px;\n  border: 1px solid var(--primary-color) !important;\n  border-radius: 4px;\n}\n\n.form-container .react-tel-input .form-control{\n  height: 100%;\n  border-radius: 4px;\n  border: unset;\n}\n/* Form Group Styling */\n.form-group {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 calc(50% - 1rem);  /* Two items per row */\n  min-width: 200px;\n  box-sizing: border-box;  /* Ensure box sizing includes padding and border */\n\n}\n\n\n\n\n.form-group label {\n  margin-bottom: 0.5rem;\n  font-weight: bold;\n  font-size: 1rem;\n  text-align: right; /* Right-align labels */\n\n}\n\n.form-group input,\n.form-group select {\n  padding: 0.75rem;\n  font-size: 1rem;\n  border: 1px solid var(--primary-color);\n  border-radius: 4px;\n  box-sizing: border-box;  /* Ensure padding and borders are included in width */\n\n}\n\n\n\nbutton {\n  flex: 1 1 100%;\n  background-color: var(--primary-color);\n  color: var(--secondary-color);\n  border: none;\n  cursor: pointer;\n  font-weight: bold;\n  padding: 0.75rem;\n  margin-top: 1rem;\n}\n\nbutton:hover {\n  background-color: var(--secondary-color);\n  color: var(--primary-color);\n  border: 2px var(--primary-color) solid;\n}\n\n.required-asterisk {\n  color: red;\n}\n.input-error {\n  border: 2px solid red;\n}\n\n.error-message {\n  color: red;\n  font-size: 12px;\n}\n\n.required-asterisk {\n  color: red;\n}\n/* Styling for textarea */\n.form-container textarea {\n  width: 100%; /* Make the textarea take full width */\n  padding: 0.75rem; /* Adjust padding for better spacing */\n  font-size: 1rem; /* Set font size */\n  border: 1px solid var(--primary-color); /* Border styling */\n  border-radius: 4px; /* Rounded corners */\n  box-sizing: border-box; /* Ensure padding and borders are included in width */\n  resize: vertical; /* Allow vertical resizing, but restrict horizontal resizing */\n}\n\n/* Ensure the textarea takes full width and behaves like a standalone field */\n.form-group.textarea-group {\n  flex: 1 1 100%; /* Take the full row */\n  width: 100%; /* Ensure 100% width */\n  margin-bottom: 1rem; /* Add some space below the textarea */\n}\n\n/* Adjust label positioning for textarea */\n.form-group.textarea-group label {\n  margin-bottom: 0.5rem;\n  font-weight: bold;\n  font-size: 1rem;\n  text-align: right; /* Right-align labels */\n}\n.social-media-icon {\n  color: #555; /* Icon color */\n  font-size: 0.75rem; /* Adjust icon size */\n  margin-left: 8px; /* Space between the label and icon */\n  vertical-align: middle; /* Ensure the icon is aligned vertically with the input text */\n}\n.enhanced-title-border {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 1rem 0;\n}\n\n.enhanced-title-border::before,\n.enhanced-title-border::after {\n  content: '';\n  height: 2px;\n  width: 110px;\n  margin: 0 1rem;\n  background-color:var(--primary-color)\n}\n\n.enhanced-title-border .circle {\n  width: 10px;\n  height: 10px;\n  border: 2px solid var(--primary-color);\n  border-radius: 50%;\n  background: transparent;\n}\n\nh1 {\n  font-weight: bold;\n}\n.center-text{\n  text-align: center;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .form-container {\n    flex-direction: column;\n  }\n\n  .form-group {\n    flex: 1 1 100%;  /* Single column layout on smaller screens */\n    width: 100%;      /* Ensure 100% width */\n\n    \n  }\n\n   /* Ensuring inputs take full width */\n   .form-group input,\n   .form-group select {\n     width: 100%;      /* Make input fields take full width */\n     padding: 0.75rem;\n     font-size: 1rem;\n     border: 1px solid var(--primary-color);\n     border-radius: 4px;\n   }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
